import React, { useEffect, useRef } from 'react';
import HomePage from 'pages/home/HomePage';
import { observer } from 'mobx-react';
import Layout from 'components/Layout/Layout';

import ProfilePage from 'pages/profile/ProfilePage';
import { Redirect, Route, Switch } from 'react-router-dom';
import SettingsPage from 'pages/settings/SettingsPage';
import UsersPage from 'pages/users/UsersPage';
import PostsPage from 'pages/posts/PostsPage';
import MessagesPage from 'pages/messages/MessagesPage';

import { useStores } from 'hooks/useStores';
import { APP_ROUTES } from '_app/routes';
import { SWRConfig } from 'swr';
import { frontApi } from '_app/api';
import BotsPage from 'pages/bots/BotsPage';

const Admin = () => {
  const socket = useRef(null);

  const {
    authStore: {
      isAuthenticated,
    },
    rolesStore: {
      // roles,
      fetchRoles,
    },
    gamesStore: {
      // games,
      fetchGames,
    },
    languagesStore: {
      // languages,
      fetchLanguages,
    }
  } = useStores();

  useEffect(() => {
    if (isAuthenticated) {
      fetchRoles();
      fetchGames();
      fetchLanguages();
      // socket.current = new Sockets('')
    }

    return () => {
      socket.current?.closeSocket();
    }
  }, [isAuthenticated])

  if (!isAuthenticated) {
    return <Redirect to={APP_ROUTES.SIGN_IN} />;
  }

  return (
    <Layout>
      <SWRConfig
        value={{ fetcher: (url) => frontApi(url).then((r) => r.data) }}
      >
        <Switch>
          <Route exact path={APP_ROUTES.HOME}>
            <HomePage />
          </Route>
          <Route exact path={APP_ROUTES.SETTINGS}>
            <SettingsPage />
          </Route>
          <Route exact path={APP_ROUTES.PROFILE}>
            <ProfilePage />
          </Route>
          <Route exact path={APP_ROUTES.USERS}>
            <UsersPage />
          </Route>
          <Route exact path={APP_ROUTES.MESSAGES}>
            <MessagesPage />
          </Route>
          <Route exact path={APP_ROUTES.POSTS}>
            <PostsPage />
          </Route>
          <Route exact path={APP_ROUTES.BOTS}>
            <BotsPage />
          </Route>
          <Redirect from="*" to={APP_ROUTES.HOME} />
        </Switch>
      </SWRConfig>
    </Layout>
  );
};

export default observer(Admin);
